/**
 * Date filter shared by the dashboard summary and the payment lists it drives.
 * Dates are ISO `yyyy-MM-dd` strings, matching what the API expects.
 */
export interface PaymentDateFilter {
  useDepositDate: boolean;
  fromDate: string;
  toDate: string;
}

/** How far back the summary looks by default. */
export const DEFAULT_PAYMENT_LOOKBACK_MONTHS = 18;

const toIsoDate = (date: Date): string => date.toISOString().split('T')[0];

export function createDefaultPaymentDateFilter(today: Date = new Date()): PaymentDateFilter {
  const from = new Date(today.getTime());
  from.setMonth(from.getMonth() - DEFAULT_PAYMENT_LOOKBACK_MONTHS);
  return {
    useDepositDate: false,
    fromDate: toIsoDate(from),
    toDate: toIsoDate(today)
  };
}

export function isSamePaymentDateFilter(a: PaymentDateFilter, b: PaymentDateFilter): boolean {
  return a.useDepositDate === b.useDepositDate
    && a.fromDate === b.fromDate
    && a.toDate === b.toDate;
}
